import { type TinyCompany, type TinyTeam, type TinyUser } from '../model'
import { isDefined, isEmpty, isNotDefined } from './isEmpty'
import { getName } from './names'

type Names = {
  firstName?: string
  lastName?: string
  preferredName?: string
  name?: string
}

export type SearchableValue = Names | string | number | undefined

export const isIncludedIn = (target: SearchableValue, searchKey: string): boolean => {
  if (isNotDefined(target)) return false
  if (typeof target === 'object' && 'firstName' in target) {
    const { firstName, lastName, preferredName, name } = target
    const searchKeys = [firstName, lastName, preferredName, name]
    if (isDefined(firstName) && isDefined(lastName)) {
      searchKeys.push(getName({ firstName, lastName, preferredName }))
      searchKeys.push(getName({ firstName, lastName, preferredName }, { order: 'last, first' }))
    }
    return searchKeys.some((value) => isIncludedIn(value, searchKey))
  }
  return target.toString().toLowerCase().includes(searchKey)
}

export const searchIncludes = (targets: SearchableValue[], searchKey: string): boolean => {
  if (isEmpty(searchKey)) return true
  const queryKey = searchKey.toLowerCase()
  return targets.some((target) => isIncludedIn(target, queryKey))
}

export const searchUser = <T extends TinyUser>(user: T, searchKey: string): boolean =>
  searchIncludes([JSON.stringify(user), user], searchKey)

export const searchTeam = <T extends TinyTeam>(team: T, searchKey: string): boolean =>
  searchIncludes([JSON.stringify(team)], searchKey)

export const searchCompany = <T extends TinyCompany>(company: T, searchKey: string): boolean =>
  searchIncludes([JSON.stringify(company)], searchKey)
